import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

const CURRICULUM_ZILL_CONTENT_GROUP: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  information: {
    single: 'Inhouds groep',
    plural: 'Inhouds groepen',
  },
  buildingBlocks: [{ type: NodeType.CURRICULUM_ZILL_DEVELOPMENT_CONTENT }],
  edit: [],
  showPlaceholder: true,
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default CURRICULUM_ZILL_CONTENT_GROUP;
